export default __webpack_public_path__ + "static/media/cargo-home-img-3.6cedbb2c.jpeg";